import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export const DemoBar = ({ name }) => {
  const { t } = useLanguage();

  return (
    <div
      data-testid="demo-bar"
      className="sticky top-0 z-50 flex items-center justify-between gap-4 border-b border-white/10 bg-black/70 px-4 py-2.5 backdrop-blur-xl md:px-8"
    >
      <p className="truncate text-xs text-white/70 md:text-sm">
        {t("demobar.demo")} <span className="font-semibold text-white">{name}</span> {t("demobar.by")}{" "}
        <span className="text-[#FF3333]">Ny hjemmeside NU</span>
      </p>
      <div className="flex shrink-0 items-center gap-4">
        <Link
          data-testid="demo-back-link"
          to="/"
          className="flex items-center gap-1.5 text-xs text-white/70 transition-colors duration-300 hover:text-white md:text-sm"
        >
          <ArrowLeft className="h-3.5 w-3.5" /> {t("demobar.back")}
        </Link>
        <Link
          data-testid="demo-cta-link"
          to="/#kontakt"
          className="flex items-center gap-1 rounded-full bg-[#FF3333] px-4 py-1.5 text-xs font-semibold text-white transition-transform duration-300 hover:scale-105 md:text-sm"
        >
          {t("demobar.cta")} <ArrowUpRight className="h-3.5 w-3.5" />
        </Link>
      </div>
    </div>
  );
};
